import { useQuery } from "@apollo/client"
import { GetContractsForMarketDay } from "../../api/contract"
import { useAppContext } from "../../contexts/AppContext"
import { buildContractListForMarketDay, ContractList } from "../../models/contract/ContractList"
import React from "react"

type Props = {
    onContractsFetch: (contracts: ContractList[]) => void
    marketDay?: string
}

export const DataContractsOpenned: React.FC<Props> = ({ onContractsFetch, marketDay }) => {

    const { millSelected } = useAppContext()

    useQuery(GetContractsForMarketDay, {
        skip: !marketDay || !millSelected,
        variables: {
            filter: {
                market_day: marketDay,
                organisation_id: millSelected?.id
            }
        },
        context: {
            headers: {
                "role": "usermill"
            }
        },
        onCompleted: (data: any) => {
            const contracts: ContractList[] = (data?.ne_contract_list?.contracts ?? [])
                .map((c: any) => buildContractListForMarketDay(c))
                .sort((c1: ContractList, c2: ContractList) => c1.id > c2.id ? -1 : c1.id === c2.id ? 0 : 1)
            onContractsFetch(contracts)
        }
    })

    return <></>
}
